import TextWithTooltipIcon from "./TextWithTooltipIcon";
import IconWarning from "ui/icons/status/IconWarning";
import IconInfo from "ui/icons/status/IconInfo";

## Basic Usage

<TextWithTooltipIcon
  text="Field Label"
  tooltip="This is helpful information about the field."
/>

---

## Form Field Labels

<div style={{ display: "flex", flexDirection: "column", gap: "1rem", maxWidth: "300px" }}>
  <div>
    <TextWithTooltipIcon text="Email Address" tooltip="We'll never share your email with anyone." />
    <input type="email" placeholder="you@example.com" style={{ width: "100%", marginTop: "0.25rem", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }} />
  </div>
  <div>
    <TextWithTooltipIcon text="API Key" tooltip="Find your API key in your account settings under Developer Tools." />
    <input type="password" placeholder="Enter API key" style={{ width: "100%", marginTop: "0.25rem", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }} />
  </div>
</div>

---

## Rich Tooltip Content

`tooltip` takes any node, so a tooltip can hold structure rather than a single sentence. Use
`tooltipClassName` when that structure needs its own width or typography — the bubble caps at 250px
by default, which a `--tooltip-max-width` of your own overrides.

<TextWithTooltipIcon
  text="3 lots available"
  tooltip={
    <div>
      <span>Available lots:</span>
      <ul>
        <li>1 at this location</li>
        <li>2 from June Lake</li>
      </ul>
    </div>
  }
/>

---

## Custom Icons

<div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
  <TextWithTooltipIcon
    text="Default info icon"
    tooltip="Uses the default info icon."
  />
  <TextWithTooltipIcon
    text="Warning icon"
    tooltip="This field has validation requirements."
    icon={<IconWarning size={16} />}
  />
  <TextWithTooltipIcon
    text="Custom info icon"
    tooltip="A different info icon style."
    icon={<IconInfo size={16} />}
  />
</div>

---

## Rich Text Trigger Content

<TextWithTooltipIcon
  text={<span><strong>Important:</strong> Configuration</span>}
  tooltip="Changing this setting requires a restart."
/>

---

## Settings Panel Example

<div style={{ border: "1px solid #e5e5e5", borderRadius: "8px", padding: "1rem", maxWidth: "400px" }}>
  <h4 style={{ margin: "0 0 1rem" }}>Notification Settings</h4>
  <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <TextWithTooltipIcon text="Email notifications" tooltip="Receive updates via email when important events occur." />
      <input type="checkbox" defaultChecked />
    </div>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <TextWithTooltipIcon text="Push notifications" tooltip="Browser notifications for real-time updates. Requires browser permission." />
      <input type="checkbox" />
    </div>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <TextWithTooltipIcon text="Weekly digest" tooltip="A summary of activity sent every Monday morning." />
      <input type="checkbox" defaultChecked />
    </div>
  </div>
</div>

---

## Table Header Example

<table style={{ width: "100%", borderCollapse: "collapse" }}>
  <thead>
    <tr style={{ borderBottom: "1px solid #e5e5e5" }}>
      <th style={{ textAlign: "left", padding: "0.5rem" }}>
        <TextWithTooltipIcon text="Name" tooltip="Full name of the user" />
      </th>
      <th style={{ textAlign: "left", padding: "0.5rem" }}>
        <TextWithTooltipIcon text="Status" tooltip="Current account status" />
      </th>
      <th style={{ textAlign: "left", padding: "0.5rem" }}>
        <TextWithTooltipIcon text="Last Active" tooltip="Most recent login timestamp" />
      </th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td style={{ padding: "0.5rem" }}>John Doe</td>
      <td style={{ padding: "0.5rem" }}>Active</td>
      <td style={{ padding: "0.5rem" }}>2 hours ago</td>
    </tr>
    <tr>
      <td style={{ padding: "0.5rem" }}>Jane Smith</td>
      <td style={{ padding: "0.5rem" }}>Inactive</td>
      <td style={{ padding: "0.5rem" }}>3 days ago</td>
    </tr>
  </tbody>
</table>


